import { PermissionsEnum } from '@/auth/interfaces';

export const SAVE_SECTOR_PERMISSIONS = [
  PermissionsEnum.api_view_pais,
  PermissionsEnum.api_view_provincia,
  PermissionsEnum.api_view_ciudad,
  PermissionsEnum.api_view_zona,
];
